import { Layout } from 'CorePackage/MainModule/components/Layout';

import { KnmPreview } from './KnmPreview';

export const KnmPreviewPage = () => (
  <Layout withFooter>
    <KnmPreview />
  </Layout>
);
